import { httpsCallable } from 'firebase/functions'
import { functions } from '../../config/firebase'
import { AdminUser } from '../../types/admin'
import { logger } from '../../utils/logger'

export class AdminsService {
  /**
   * Get all admin users
   */
  static async getAdmins(): Promise<AdminUser[]> {
    try {
      logger.log('📦 Fetching admin users...')
      const listAllAdminUsers = httpsCallable<void, AdminUser[]>(functions, 'listAllAdminUsers')
      const result = await listAllAdminUsers()
      logger.log('✅ Admin users received:', result.data)
      return result.data || []
    } catch (error) {
      logger.error('Error fetching admin users:', error)
      throw error
    }
  }

  /**
   * Add a user as admin by email
   */
  static async setUserToAdmin(email: string): Promise<boolean> {
    try {
      logger.log(`🔑 Setting user ${email} as admin...`)
      const setUserToAdmin = httpsCallable<string, { success: boolean }>(functions, 'setUserToAdmin')
      const result = await setUserToAdmin(email)
      logger.log('✅ User set as admin:', result.data)
      return result.data.success
    } catch (error) {
      logger.error('Error setting user as admin:', error)
      throw error
    }
  }

  /**
   * Remove admin privileges from a user by email
   */
  static async removeAdmin(email: string): Promise<boolean> {
    try {
      logger.log(`🔒 Removing admin privileges for user ${email}...`)
      const removeUserFromAdmins = httpsCallable<string, { success: boolean }>(functions, 'removeUserFromAdmins')
      const result = await removeUserFromAdmins(email)
      logger.log('✅ Admin privileges removed:', result.data)
      return result.data.success
    } catch (error) {
      logger.error('Error removing admin privileges:', error)
      throw error
    }
  }
}